import { useState } from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";
import { copyText } from "@/lib/clipboard";
import { useI18n } from "@/i18n/I18nContext";

// Copy with a visible "Copié ✓" confirmation (2 s); works in the installed app / Samsung Internet.
export const CopyButton = ({ text, label, className = "btn-red btn-sm", testId }) => {
  const { t } = useI18n();
  const [done, setDone] = useState(false);
  const copy = async () => {
    if (await copyText(typeof text === "function" ? text() : text)) {
      setDone(true);
      setTimeout(() => setDone(false), 2000);
    } else {
      toast.error(t("keys.copyFailed"));
    }
  };
  return (
    <button type="button" className={`${className} max-w-full whitespace-normal text-start`} onClick={copy} aria-live="polite" data-testid={testId}>
      {!done && <Copy className="h-4 w-4 shrink-0" />} <span className="min-w-0 break-words">{done ? t("keys.copiedCheck") : label}</span>
    </button>
  );
};
